import {actionTypes} from '@/core/constants'
import api from '@/core/apiclient'

export default {
    async [actionTypes.RELATORIO.RELATORIOS_TCE.GERAR_RELATORIOS_TCE](context, params) {
        const {data} = await api.relatoriosTce.gerarRelatoriosTce(buildFilters(params))
        let blob = new Blob([data], {
            type: `application/${params.formato.toLowerCase()}`
        })
        let nomeRelatorio = resolveNomeRelatorio(params.tipoRelatorio, params.tipo)

        const downloadLink = document.createElement('a')
        document.body.appendChild(downloadLink)
        downloadLink.setAttribute('type', 'hidden')
        downloadLink.href = window.URL.createObjectURL(blob)
        downloadLink.download = nomeRelatorio + '.' + params.formato.toLowerCase()
        downloadLink.click()
    }
}

function buildFilters(params) {
    return {
        formato: {value: params.formato},
        dataInicio: {value: params.dataInicio},
        dataFim: {value: params.dataFim},
        orgao: {value: params.orgao},
        tipoRelatorio: {value: params.tipoRelatorio},
        tipo: {value: params.tipo},
        ano: {value: params.ano}
    }
}

function resolveNomeRelatorio(tipoRelatorio, tipo) {
    if (!tipoRelatorio) {
        throw new Error('O tipo do relatorio não pode ser vazio ou indefinido.')
    }

    switch (tipoRelatorio) {
        case 'INVENTARIO_DOS_BENS_INTANGIVEIS':
            return nomeInventario(tipo)
        case 'DEMONSTRATIVO_ANALITICO_ENTRADAS_SAIDAS':
            return 'RelatorioDEMAMI-intangivel'
        case 'RESUMO_INVENTARIO_MATERIAL_INTANGIVEL':
            return 'RelatorioRIMI-intangivel'
        default:
            throw new Error(`Tipo de relatório inválido: ${tipoRelatorio}`)
    }
}

function nomeInventario(tipo) {
    if (tipo === 'ANALITICO') {
        return 'RelatorioINVINT-intangivel'
    }
    return 'RelatorioRIMI-intangivel'
}
